module.exports = __webpack_public_path__ + "static/img/tutorial_save_screen@2x.ad3542e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/FPS/tutorial_save_screen@2x.png
// module id = HiCv
// module chunks = 1